import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function LiveBadge() {
  const { t } = useTranslation('cameras');
  return (
    <Box
      sx={{
        bgcolor: 'red',
        color: 'white',
        position: 'absolute',
        top: '24px',
        left: '24px',
        px: 2,
        py: 0.2,
        textTransform: 'uppercase',
        borderRadius: '4px',
      }}
    >
      <Typography variant="subtitle2">{t('live')}</Typography>
    </Box>
  );
}

export default LiveBadge;
